import { getTestIds } from 'seagull/utils/TestIds';
export const GetNotifyRowTID = (parentTestId)=>getTestIds(parentTestId);
